
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/edit-profile",
      function () {
        return require("private-next-pages/edit-profile.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/edit-profile"])
      });
    }
  